var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pbi_filter0_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pbi_filter1_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pbi_paint0_linear",
    x1: 46.6667,
    y1: -8.97795e-7,
    x2: 88.8653,
    y2: 89.4466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pbi_paint1_linear",
    x1: 31.9974,
    y1: 24,
    x2: 67.4859,
    y2: 92.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pbi_paint2_linear",
    x1: 11.9974,
    y1: 48,
    x2: 31.6083,
    y2: 94.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pbi_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pbi_clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pbi_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 72,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 4C52 1.79086 53.7909 0 56 0H80C82.2091 0 84 1.79086 84 4V92C84 94.2091 82.2091 96 80 96H16C13.7909 96 12 94.2091 12 92V52C12 49.7909 13.7909 48 16 48H32.0001V28C32.0001 25.7909 33.791 24 36.0001 24H52V4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#pbi_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 0L84 96H52L52 0H84Z",
    fill: "url(#pbi_paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pbi_filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 28.4V96.4H32V24.4H60C62.2091 24.4 64 26.1909 64 28.4Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pbi_filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 30V98H32V26H60C62.2091 26 64 27.7909 64 30Z",
    fill: "black",
    fillOpacity: 0.18
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64 28V96H32V24H60C62.2091 24 64 25.7909 64 28Z",
    fill: "url(#pbi_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 48V96H44V52C44 49.7909 42.2091 48 40 48H12Z",
    fill: "url(#pbi_paint2_linear)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/PowerBI.f6bfe82459d60d6d422bb3cf6c8fd58d.svg";
export { ForwardRef as ReactComponent };